import { h } from 'preact';
export const AlertOctagon = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" }),
        h("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
        h("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })));
};
//# sourceMappingURL=alert-octagon.js.map